"use strict";
var ApiTransactionContainer = (function () {
    function ApiTransactionContainer() {
    }
    return ApiTransactionContainer;
}());
exports.ApiTransactionContainer = ApiTransactionContainer;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-transaction-container.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-transaction-container.model.js